<template>
  <div
    class="d-flex justify-center align-center w-100 pa-0 ma-0"
    :style="{
      width: '100%',
      height: Height || '500px',
      minHeight: Height || '500px',
      position: 'relative',
    }"
  >
    <canvas
      ref="elemento"
      :id="IdGrafico"
      :style="{
        maxHeight: Height || '500px',
        height: '100%',
        width: '100%',
      }"
    ></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
Chart.register(ChartDataLabels);

export default {
  props: [
    "Labels",
    "DatosGrafico",
    "Title",
    "Labelsdataset",
    "IdGrafico",
    "BackgroundColor",
    "Suffix",
    "Height",
    "LegendPosition",
    "ShowLegend",
  ],
  data() {
    return {
      chartInstance: null,
    };
  },
  methods: {
    generarGrafico: function () {
      var popCanvas = document.getElementById(this.IdGrafico);
      if (!popCanvas) return;

      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      const suffix = this.Suffix || "";
      const defaultColors = [
        "rgb(255, 99, 132)",
        "rgb(27, 205, 249)",
        "rgb(218, 247, 166)",
        "rgb(255, 205, 86)",
        "rgb(27, 216, 176)",
        "rgb(253, 152, 37)",
        "rgb(254, 243, 80)",
        "rgb(179, 241, 238)",
        "rgb(125, 254, 80)",
        "rgb(54, 162, 235)",
        "#E91E63",
        "#9C27B0",
        "#673AB7",
        "#3F51B5",
        "#2196F3",
        "#00BCD4",
        "#009688",
        "#4CAF50",
        "#8BC34A",
        "#CDDC39",
        "#FFEB3B",
        "#FFC107",
        "#FF9800",
        "#FF5722",
        "#795548",
        "#607D8B",
        "#F06292",
        "#BA68C8",
        "#4DD0E1",
        "#81C784",
      ];

      const showLegend =
        this.ShowLegend !== false &&
        this.ShowLegend !== "false" &&
        this.LegendPosition !== "none";

      this.chartInstance = new Chart(popCanvas, {
        plugins: [ChartDataLabels],
        type: "pie",
        data: {
          labels: this.Labels,
          datasets: [
            {
              label: this.Labelsdataset || "Porcentaje",
              data: this.DatosGrafico,
              backgroundColor: this.BackgroundColor || defaultColors,
              hoverOffset: 6,
              radius: "85%",
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: 12,
          },
          plugins: {
            title: {
              display: !!this.Title,
              text: this.Title,
            },
            legend: {
              display: showLegend,
              position: this.LegendPosition || "bottom",
              labels: {
                color: "black",
                font: {
                  size: 11,
                },
              },
            },
            datalabels: {
              anchor: "center",
              formatter: (dato) =>
                dato !== null && dato !== undefined ? dato + suffix : "",
              color: "black",
              font: {
                family: '"Times New Roman", Times, serif',
                size: "10",
                weight: "bold",
              },
              padding: 4,
              borderWidth: 2,
              borderRadius: 8,
              backgroundColor: "white",
            },
          },
          tooltips: {
            yAlign: "bottom",
            xAlign: "center",
            xPadding: 25,
            yPadding: 15,
            _bodyAlign: "center",
            _footerAlign: "center",
            backgroundColor: "#ccc",
            titleFontSize: 16,
            titleFontColor: "#0066ff",
            bodyFontColor: "#000",
            bodyFontSize: 14,
            displayColors: false,
          },
        },
      });
    },
  },
  watch: {
    DatosGrafico: {
      handler() {
        this.$nextTick(() => {
          this.generarGrafico();
        });
      },
      deep: true,
    },
    Labels: {
      handler() {
        this.$nextTick(() => {
          this.generarGrafico();
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.generarGrafico();
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },
};
</script>
